<template lang="pug">
  v-content
    v-container(fluid fill-height style="min-height: 100vh")
      v-layout(align-center justify-center)
        v-flex(style="width: 80%; max-width: 800px")
          v-card.elevation-12(style="border-radius: 4px")
            //電腦版
            v-layout(v-if="$vuetify.breakpoint.smAndUp")
              v-flex.login-left(xs6)
                v-img(:src="background", height="480px", style="border-radius: 4px 0 0 4px")
                  v-layout(wrap align-content-space-between, style="height: 100%")
                    v-flex(xs12)
                      v-layout(wrap)
                        v-flex(style="padding-left: 30px;padding-top: 60px;")
                          v-img(:src="logo" style="width: 100%;max-width: 200px;")
                        v-flex(d-inline-flex align-center style="width: 100%;padding: 20px 48px 24px 32px;")
                          v-divider(style="background-color: #000;")
                          span.logo-subtitle {{$t('auth.logoSubtitle')}}
                          v-divider(style="background-color: #000;margin-right: 25px;")
                    v-flex.pb-4(xs12 style="padding-left: 30px")
                      span.caption(style="color: #424242")
                        b © Copyright {{ nowYear }} - ACH Taiwan
              transition(name="slide-fade", mode="out-in")
                login(@btnEvent="btnEvent" v-if="!showForgetPw && !isResetPw && !firstLogin && !isGoogleLogin && !isAdminLogin ")
                firstLogin(@btnEvent="btnEvent" :password="firstLoginPw" v-else-if="firstLogin")
                googleLogin(@btnEvent="btnEvent" v-else-if="isGoogleLogin")
                adminLogin(@btnEvent="btnEvent" v-else-if="isAdminLogin")
                forgetPw(@btnEvent="btnEvent" :resetPw="isResetPw" v-else)
            // 手機版
            v-container(style="padding: 0" v-else)
              v-img(:src="mobileBackground" height="170px")
                v-layout(column, style="height: 100%")
                  v-flex(d-inline-flex align-end justify-center)
                    v-img(:src="logo" style="width: 100%;max-width: 200px;")
                  v-flex.pb-2(d-inline-flex align-center justify-center text-xs-center style="width: 100%;")
                    v-divider(style="background-color: #000;")
                    span.logo-subtitle {{$t('auth.logoSubtitle')}}
                    v-divider(style="background-color: #000;")
              transition(name="slide-fade", mode="out-in")
                login(mobile @btnEvent="btnEvent" v-if="!showForgetPw && !isResetPw && !firstLogin && !isGoogleLogin && !isAdminLogin")
                firstLogin(mobile @btnEvent="btnEvent" :password="firstLoginPw" v-else-if="firstLogin")
                googleLogin(mobile @btnEvent="btnEvent" v-else-if="isGoogleLogin")
                adminLogin(mobile @btnEvent="btnEvent" v-else-if="isAdminLogin")
                forgetPw(mobile @btnEvent="btnEvent" :resetPw="isResetPw" v-else)
</template>

<script>
import moment from 'moment'
import login from './components/Login'
import forgetPw from './components/ForgetPw'
import firstLogin from './components/FirstLogin'
import googleLogin from './components/GoogleLogin'
import adminLogin from './components/AdminLogin'
import { global } from 'mixins/global'



export default {
  mixins: [global],
  data () {
    return {
      isResetPw: false,
      showForgetPw: false,
      nowYear: moment().format('YYYY'),
      logo: require('@/assets/img/pic_achtaiwan_logo@2x.png'),
      background: require('@/assets/img/bg_login.png'),
      mobileBackground: require('@/assets/img/bg_login_m.png'),
      firstLogin: false,
      isGoogleLogin: false,
      isAdminLogin: false,
      firstLoginPw: ''
    }
  },
  components: {
    login,
    forgetPw,
    googleLogin,
    adminLogin,
    firstLogin
  },
  computed: {
    recordPath () {
      return this.$store.getters.getRecordPath
    }
  },
  mounted () {
    if (this.$route.name === 'resetPw') {
      this.isResetPw = true
    }
    if (this.$route.name === 'admin') {
      this.isGoogleLogin = true
    }
    if (this.$route.name === 'adminLogin') {
      this.isAdminLogin = true
    }
  },
  methods: {
    btnEvent (event) {
      switch (event.action) {
        case 'login':
          this.firstLogin = event.firstLogin
          this.firstLoginPw = event.password
          if (!this.firstLogin) {
            this.$store.commit('SET_LOADING_STATUS', true)
            if (this.recordPath) {
              this.$router.push(this.recordPath)
            } else {
              this.$router.push('/index')
            }
          }
          break
        case 'forgetConfirm':
          break
        case 'googleLogin':
          break
        case 'adminLogin':
          break
        case 'forgetPw':
          this.showForgetPw = true
          break
        case 'backToLogin':
          if (this.$route.name === 'resetPw') {
            this.showForgetPw = event.data.gotoForgetPw
            this.isResetPw = false
            this.$router.push('/login')
          } else {
            if (this.firstLogin) {
              this.firstLogin = false
              this.doLogout()
            }
            this.showForgetPw = false
          }
          break
      }
    }
  },
  watch: {
    '$route' (from, to, next) {
      if (from.name === 'resetPw') {
        this.isResetPw = true
      } else {
        this.isResetPw = false
      }
    }
  }
}
</script>

<style lang="sass" scoped>
  .login-left
    position: relative
    &:after
      border-color: white white transparent transparent
      border-style: solid
      border-width: 480px 0px 0px 50px
      content: ""
      position: absolute
      top: 0
      right: 0

  .slide-fade-enter-active
    transition: all .6s ease

  .slide-fade-leave-active
    transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0)

  .slide-fade-enter, .slide-fade-leave-active
    transform: translateX(20px)
    opacity: 0

  .logo-subtitle
    color: #424242
    font-size: 14px
    width: 100%
    min-width: 175px
    margin: 0 10px
    font-weight: bold
</style>

<style lang="sass">
  .card__media__content
    height: 100%
</style>
